import { Component, OnInit } from '@angular/core';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.page.html',
  styleUrls: ['./terms-conditions.page.scss'],
})
export class TermsConditionsPage implements OnInit {

  logo;
  description=''
  title;
  isLoaded=false;
    constructor(public globals:GlobalVariable,
      public server :UserApiService) {
        this.privacy();
       }
  
    ngOnInit() {
    }
  privacy(){
    this.server.privacyPolicy('terms').subscribe(res=>{
      this.isLoaded=true;
      console.log(res)
      if(res.success==true){
        this.title=res.data.title
        this.logo=res.data.logo;
        this.description=res.data.description
  
      }
    },err=>{
      this.isLoaded=true;
  
    })
  }
  }
  